import type { ReactElement, ReactNode } from 'react';
import type { Tone } from '../lib/labels';

interface BadgeProps {
  readonly tone: Tone;
  readonly children: ReactNode;
  /** Ponto solido a esquerda — usado em qualidade de canal e status de canal. */
  readonly dot?: boolean;
  /** Altura de botao `btn--sm`, para alinhar quando fica ao lado de um. */
  readonly tall?: boolean;
}

const DOT_COLOR: Readonly<Record<Tone, string>> = {
  blue: 'var(--blue)',
  pink: 'var(--pink)',
  mint: 'var(--mint)',
  amber: 'var(--amber)',
  rose: 'var(--rose)',
  slate: 'var(--text-3)',
};

export function Badge({ tone, children, dot = false, tall = false }: BadgeProps): ReactElement {
  return (
    <span className={`badge badge--${tone}${tall ? ' badge--tall' : ''}`}>
      {dot ? <span className="dot" style={{ background: DOT_COLOR[tone] }} /> : null}
      {children}
    </span>
  );
}
